"use client";

import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = ComponentPropsWithoutRef<"button"> & {
  loading?: boolean;
  children: ReactNode;
  variant?: "primary" | "mint";
};

export function AuthButton({
  children,
  loading,
  disabled,
  className,
  variant = "primary",
  type = "button",
  ...rest
}: Props) {
  const isDisabled = disabled || loading;
  return (
    <button
      type={type}
      disabled={isDisabled}
      className={cn(
        "inline-flex h-12 w-full items-center justify-center rounded-full text-[15px] font-medium transition-all active:scale-[0.99]",
        variant === "primary" &&
          "bg-surface border border-line text-ink hover:bg-surface-mute hover:border-line-strong",
        variant === "mint" &&
          "bg-mint text-[#052e25] hover:bg-mint-dark hover:text-white shadow-[0_0_40px_-10px_rgba(52,211,153,0.55)]",
        isDisabled && "opacity-60 cursor-not-allowed active:scale-100",
        className,
      )}
      {...rest}
    >
      {loading ? (
        <span className="inline-block h-4 w-4 shrink-0 rounded-full border-2 border-current/30 border-t-current animate-spin" />
      ) : (
        children
      )}
    </button>
  );
}
